import { render, staticRenderFns } from "./EmDataTable.vue?vue&type=template&id=24f95c48&scoped=true"
import script from "./EmDataTable.vue?vue&type=script&lang=js"
export * from "./EmDataTable.vue?vue&type=script&lang=js"
import style0 from "./EmDataTable.vue?vue&type=style&index=0&id=24f95c48&prod&scoped=true&lang=css"
import style1 from "./EmDataTable.vue?vue&type=style&index=1&id=24f95c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f95c48",
  null
  
)

export default component.exports